export default __webpack_public_path__ + "static/ASLA_AptosBollard_2-b58c12385a508c9bab1fa39024d994df.png";